function goToTop() {
    const positionShow = window.innerHeight * 2;
    const btns = document.querySelectorAll('.js-scroll-to-top');
    const className = 'visible-btn';
    const { body } = document;
    window.addEventListener('scroll', function (e) {
        const currentPosition = window.scrollY;
        if (positionShow < currentPosition) {
            if (!body.classList.contains(className)) {
                btns &&
                    btns.forEach((item) => {
                        item.classList.add(className);
                    });
                body.classList.add(className);
            }
        }
        else if (body.classList.contains(className)) {
            btns &&
                btns.forEach((item) => {
                    item.classList.remove(className);
                });
            body.classList.remove(className);
        }
    });
    btns &&
        btns.forEach((item) => {
            if (item instanceof HTMLElement) {
                item.addEventListener('click', (event) => {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                });
            }
        });
}
export default goToTop;
